export default __webpack_public_path__ + "static/media/prismastic-lake-mobile.33822113.jpg";